import { render, staticRenderFns } from "./GuppywidgetChatBoxFooter.vue?vue&type=template&id=7820c83d&scoped=true&"
import script from "./GuppywidgetChatBoxFooter.vue?vue&type=script&lang=js&"
export * from "./GuppywidgetChatBoxFooter.vue?vue&type=script&lang=js&"
import style0 from "./GuppywidgetChatBoxFooter.vue?vue&type=style&index=0&id=7820c83d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7820c83d",
  null
  
)

export default component.exports